import { AccountConnectorServiceEnum } from '~/generated/graphql';
import { useCurrentAccount } from '~/hooks/account';
import { configurations } from '~/lib/configuration';

export type AccountConnector = {
  id: string;
  service: AccountConnectorServiceEnum;
  status: string;
};

const getConnectorsByService = (connectors: AccountConnector[]) => {
  const connectorsByService: Record<string, AccountConnector> = {};
  if (connectors) {
    connectors.forEach((connector) => {
      if (connectorsByService[connector.service]) {
        if (connector.status === 'active')
          connectorsByService[connector.service] = connector;
      } else {
        connectorsByService[connector.service] = connector;
      }
    });
  }

  return connectorsByService;
};

const getSalesforceConnector = (
  connectors: Record<string, AccountConnector>,
) => {
  const connector = connectors[configurations.salesforce];
  if (connector?.status === 'active') {
    return connector;
  }

  return connectors[configurations.salesforcesandbox];
};

const useCRMConnectors = () => {
  const { account, loading } = useCurrentAccount();
  const connectors = account?.connectors;
  const connectorsByService = getConnectorsByService(
    connectors as AccountConnector[],
  );
  const salesforceConnector = getSalesforceConnector(connectorsByService);
  const hubspotConnector = connectorsByService[configurations.hubspot];
  const defaultConnector = salesforceConnector || hubspotConnector;

  return {
    defaultConnector,
    salesforceConnector,
    hubspotConnector,
    loading,
  };
};

export { useCRMConnectors };
